import axios from "axios";
import { serverUrl } from "../../../../../nestserver";

const authHeaders = () => ({
  Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
});

const call = async (method, path, { params, data, ...rest } = {}) => {
  const res = await axios({
    method,
    url: `${serverUrl}/payroll${path}`,
    params,
    data,
    headers: authHeaders(),
    ...rest,
  });
  return res.data;
};

/** Pulls the server's message out of a failed request, for message.error(). */
export const errorText = (err, fallback = "Something went wrong") => {
  const m = err?.response?.data?.message;
  if (Array.isArray(m)) return m.join(", ");
  return m || fallback;
};

export const payrollApi = {
  staff: (group) => call("get", "/staff", { params: { group } }).then((r) => r.data),
  saveProfile: (body) => call("put", "/profiles", { data: body }).then((r) => r.data),
  profileHistory: (userId) =>
    call("get", `/profiles/${userId}/history`).then((r) => r.data),

  settings: () => call("get", "/settings").then((r) => r.data),
  saveSettings: (body) => call("put", "/settings", { data: body }).then((r) => r.data),

  runByMonth: (month) => call("get", `/runs/by-month/${month}`).then((r) => r.data),
  run: (id) => call("get", `/runs/${id}`).then((r) => r.data),
  generate: (month) => call("post", "/runs/generate", { data: { month } }).then((r) => r.data),
  approve: (id) => call("post", `/runs/${id}/approve`).then((r) => r.data),
  payAll: (id, body) => call("post", `/runs/${id}/pay-all`, { data: body }).then((r) => r.data),
  deleteRun: (id) => call("delete", `/runs/${id}`).then((r) => r.data),

  updateEntry: (id, body) => call("patch", `/entries/${id}`, { data: body }).then((r) => r.data),
  payEntry: (id, body) => call("post", `/entries/${id}/pay`, { data: body }).then((r) => r.data),
  /** Resolves to the PDF Blob (not an axios response). */
  payslip: async (id) => {
    try {
      return await call("get", `/entries/${id}/payslip`, { responseType: "blob" });
    } catch (err) {
      const body = err?.response?.data;
      if (body instanceof Blob) {
        try {
          err.response.data = JSON.parse(await body.text());
        } catch (_) {
        }
      }
      throw err;
    }
  },

  adjustments: (month) => call("get", "/adjustments", { params: { month } }).then((r) => r.data),
  createAdjustment: (body) => call("post", "/adjustments", { data: body }).then((r) => r.data),
  deleteAdjustment: (id) => call("delete", `/adjustments/${id}`).then((r) => r.data),
};

export const inr = (n) =>
  `₹${(Number(n) || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const GROUP_LABEL = { instructor: "Instructor", support: "Driver / Support" };
export const ROLE_LABEL = {
  instructor: "Instructor",
  driver: "Driver",
  support_staff: "Support Staff",
};
